import { render, staticRenderFns } from "./HandIcon.vue?vue&type=template&id=c197b7d4&"
import script from "./HandIcon.vue?vue&type=script&lang=js&"
export * from "./HandIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports